const typeRoute = {
	name: 'level-types',
	path: 'level-types',
	component: () => import('@/pages/configuration/page-level-types'),
};

export default typeRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/types/index.js